import React, {ReactNode} from "react";
import {cn} from "@/lib/utils";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    children: ReactNode;
}

export const SmallTag = ({children, className, ...props}: IProps) => {
    return (
        <div className={cn('bg-white-transparent-8 font-bold text-[8px] text-orange-main uppercase py-[3px] px-[8px] rounded-[6px] text-center', className)} {...props}>{children}</div>
    )
}
